import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Element } from 'react-scroll';

import styles from '@components/join/join.module.scss';
import LabelInput from '@components/labelInput';
import { emailValidator, valueRequired } from '@utils/validators/validators';
import useRecommendEmailList from '@utils/hooks/useRecommendEmailList';
import { GUIDE_TEXT } from '@utils/validators/text';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IEmail {
  prefixName: string;
}

const Email = ({ prefixName }: IEmail) => {
  const {
    inputWrapRef,
    isOpen,
    emailText,
    emailList,
    selected,
    setSelected,
    handleOnKeyDown,
    handleOnClickEmail,
    handleOnChange,
  } = useRecommendEmailList();
  const {
    watch,
    register,
    formState: { errors },
    trigger,
    setValue,
  } = useFormContext();
  const email = watch(prefixName);

  const handleClick = (item: string) => {
    const value = `${emailText.split('@')[0]}${item}`;
    handleOnClickEmail(emailText, item);
    setValue('email', value);
    trigger('email');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    handleOnKeyDown(e);
    if (!isOpen) return;
    if (e.key === 'Enter') {
      if (selected === -1) return;
      const value = `${emailText.split('@')[0]}${emailList[selected]}`;
      setValue('email', value);
      trigger('email');
    }
  };

  const emailEls = emailList.map((item, index) => {
    const text = `${emailText.split('@')[0]}${item}`;
    const remainingText = text.split(emailText);

    return (
      <li
        key={index}
        className={cx('emailItem', { selected: selected === index })}
        onClick={() => handleClick(item)}
        onMouseOver={() => setSelected(index)}
      >
        <em className={cx('em')}>{emailText}</em>
        <span>{remainingText[1]}</span>
      </li>
    );
  });

  return (
    <Element name={prefixName} className={cx('infoWrap')}>
      <div ref={inputWrapRef} className={'inputWrap'}>
        <LabelInput
          {...register(prefixName, {
            ...valueRequired,
            validate: (value: string) => {
              return emailValidator(value);
            },
            onChange: handleOnChange,
          })}
          type="text"
          className={cx('input', { error: errors.email, success: !errors.email })}
          placeholder={'이메일'}
          onKeyDown={(e) => handleKeyDown(e)}
          isvalue={email}
          tabIndex={5}
        />
      </div>
      <ul className={cx('emailList', { visible: isOpen })}>{emailEls}</ul>
      {errors.email && <div className={cx('infoText', 'error')}>{errors.email.message as string}</div>}
      <div className={cx('infoText')}>{GUIDE_TEXT.EMAIL}</div>
    </Element>
  );
};

export default Email;
